import styles from "./index.module.css";

const Content = ({ content }) => <div className={styles.content} dangerouslySetInnerHTML={{ __html: content }} />;

export default Content;
